export { default as Sam } from './samdd'
export { default as Voakie } from './voakie'



// WEBPACK FOOTER //
// ./src/components/Modal/Developer/index.tsx